module.exports = {
  feeService: { ...require('./fees.mapper') },
};
